module.exports = fox._r("images/sprite_2.png", __webpack_public_path__ + "images/sprite_2.png");


//////////////////
// WEBPACK FOOTER
// ./images/sprite_2.png
// module id = 4
// module chunks = 2